import * as React from 'react'

import Svg, {
  G,
  Rect,
  Path,
  Defs,
  RadialGradient,
  Stop,
  ClipPath,
} from 'react-native-svg'

const MyTeam = ({ ...props }) => {
  return (
    <Svg
      width={49}
      height={48}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_103_2586)">
        <Rect x={0.333252} width={48} height={48} rx={8} fill="#F2F7FF" />
        <G clipPath="url(#clip1_103_2586)">
          <Path
            d="M39.818 36c0-.603-.036-1.198-.104-1.783a2.309 2.309 0 01.78-1.997l2.343-2.056a2.178 2.178 0 00.424-2.77l-2.506-4.115a2.178 2.178 0 00-2.656-.895l-2.921 1.147a2.305 2.305 0 01-2.132-.244 15.287 15.287 0 00-2.14-1.204 2.303 2.303 0 01-1.312-1.691l-.54-3.09A2.178 2.178 0 0026.91 15.5H22.09c-1.058 0-1.963.76-2.145 1.803l-.54 3.089a2.303 2.303 0 01-1.313 1.69c-.747.346-1.463.749-2.14 1.205a2.306 2.306 0 01-2.131.244l-2.921-1.147a2.178 2.178 0 00-2.656.895l-2.506 4.114a2.178 2.178 0 00.423 2.77l2.344 2.056c.57.5.867 1.246.78 1.998a15.397 15.397 0 000 3.566 2.31 2.31 0 01-.78 1.997l-2.344 2.056a2.178 2.178 0 00-.423 2.77l2.506 4.115c.55.904 1.67 1.281 2.656.895l2.92-1.147a2.305 2.305 0 012.133.244c.676.456 1.391.86 2.139 1.204a2.303 2.303 0 011.313 1.691l.54 3.089c.182 1.042 1.087 1.481 2.145 1.481h4.818c1.058 0 1.963-.438 2.145-1.48l.54-3.09a2.303 2.303 0 011.313-1.69 15.292 15.292 0 002.14-1.205 2.306 2.306 0 012.13-.244l2.922 1.147c.985.386 2.105.009 2.656-.895l2.506-4.114a2.178 2.178 0 00-.424-2.77l-2.343-2.056a2.31 2.31 0 01-.78-1.998c.069-.585.104-1.18.104-1.783z"
            fill="url(#paint0_radial_103_2586)"
          />
          <Path
            d="M24.5 47.635c6.426 0 11.635-5.21 11.635-11.635 0-6.426-5.21-11.635-11.635-11.635-6.426 0-11.635 5.21-11.635 11.635 0 6.426 5.209 11.635 11.635 11.635z"
            fill="#E8F1FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.167 37.322a3.513 3.513 0 004.15-3.448 3.514 3.514 0 00-3.509-3.512 3.49 3.49 0 00-3.307 2.336 4.414 4.414 0 012.666 4.623zm-2.241 3.338c1.874.652 4.112 2.863 4.799 4.778.778-.333 2.482-2.186 3.186-3.557-.926-1.556-1.789-2.99-5.04-3.446-.347-.049-.666-.074-.972-.049a4.407 4.407 0 01-1.973 2.274z"
            fill="url(#paint1_radial_103_2586)"
            fillOpacity={0.8}
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.091 37.618c-.211.039-.425.061-.641.061a3.513 3.513 0 01-3.51-3.51 3.514 3.514 0 013.51-3.51 3.49 3.49 0 013.307 2.335 4.414 4.414 0 00-2.666 4.624zm2.241 3.338c-1.874.653-4.112 2.863-4.798 4.779-.778-.334-2.483-2.187-3.187-3.557.926-1.557 1.79-2.992 5.04-3.447.347-.048.666-.074.972-.048a4.407 4.407 0 001.973 2.273z"
            fill="url(#paint2_radial_103_2586)"
            fillOpacity={0.8}
          />
          <Path
            d="M23.466 33.723a3.493 3.493 0 00-2.388 4.138 3.494 3.494 0 003.421 2.727 3.491 3.491 0 003.417-2.714 3.491 3.491 0 00-2.38-4.15 3.444 3.444 0 00-1.036-.157c-.358 0-.706.052-1.034.156z"
            fill="url(#paint3_radial_103_2586)"
          />
          <Path
            d="M30.071 46.446c-.034-.173-.032-.644-.08-.808a5.718 5.718 0 00-5.492-4.12 5.746 5.746 0 00-5.496 4.132c-.047.165-.193.633-.225.796 1.634 1.209 3.677 1.544 5.721 1.544 2.045 0 3.939-.337 5.572-1.544z"
            fill="url(#paint4_radial_103_2586)"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_103_2586"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(131.173 16.22 18.306) scale(48.9422 45.1081)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_103_2586"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(5 24.5 -21.1474 4.31579 28 21)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_103_2586"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-12.46672 24.21394 -20.90043 -10.76074 26.5 21.5)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_103_2586"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(133.168 6.09 22.817) scale(9.02185 7.86337)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_103_2586"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(148.577 8.248 24.93) scale(11.6343 9.04125)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_103_2586">
          <Rect x={0.333252} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
        <ClipPath id="clip1_103_2586">
          <Path fill="#fff" transform="translate(4 15.5)" d="M0 0H41V41H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default MyTeam
